function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15.9541H11.5M26.833 18.4541L26.373 25.3541C26.196 28.0081 26.108 29.3351 25.243 30.1441C24.378 30.9531 23.047 30.9541 20.387 30.9541H19.613C16.953 30.9541 15.622 30.9541 14.757 30.1441C13.892 29.3351 13.803 28.0081 13.627 25.3541L13.167 18.4541M17.5 20.9541L18 25.9541M22.5 20.9541L22 25.9541",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.9541H14.61C15.0124 15.9438 15.4024 15.8123 15.7289 15.5768C16.0554 15.3413 16.3033 15.0127 16.44 14.6341L16.474 14.5311L16.571 14.2401C16.654 13.9911 16.696 13.8671 16.751 13.7611C16.8592 13.5535 17.0145 13.3741 17.2045 13.2373C17.3944 13.1004 17.6138 13.01 17.845 12.9731C17.962 12.9541 18.093 12.9541 18.355 12.9541H21.645C21.907 12.9541 22.038 12.9541 22.155 12.9731C22.3862 13.01 22.6056 13.1004 22.7955 13.2373C22.9855 13.3741 23.1408 13.5535 23.249 13.7611C23.304 13.8671 23.346 13.9911 23.429 14.2401L23.526 14.5311C23.6527 14.9524 23.9148 15.3201 24.2717 15.5774C24.6285 15.8346 25.0603 15.967 25.5 15.9541",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGrey);
export default __webpack_public_path__ + "static/media/delete_grey.eb4379e76af1291b9474438501b67956.svg";
export { ForwardRef as ReactComponent };